module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-158.2cf10861.jpg";